import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Link, browserHistory, withRouter } from 'react-router';

import NavLink from '../NavLink/NavLink';
import { logout } from '../../../actions/userActions';

import './UserProfileNavbar.css';

class UserProfileNavbar extends Component {
  constructor(props) {
    super(props);

    $.noConflict();
  }

  componentDidMount() {
    this.toggleNavbar(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.toggleNavbar(nextProps);
    }
  }

  toggleNavbar = (props) => {
    const collapse = props.location.pathname.indexOf('plans-and-billing') !== -1 ? 'show' : 'hide';
    $('#plans-and-billing').collapse(collapse);
  }

  handlePlansAndBilling = (event) => {
    event.preventDefault();
    event.stopPropagation();
    browserHistory.replace('/profile/plans-and-billing');
  }

  handleEditProfile = (event) => {
    event.preventDefault();
    browserHistory.replace('/profile/edit');
  }

  handleLogout = () => {
    // destroy the session data and log out
    this.props.logout();
    browserHistory.replace('/');
  }

  render() {
    return (
      <div className="UserProfileNavbar px-md-3 px-lg-4">
        <nav className="nav nav-pills flex-column">
          <NavLink to="/profile/edit" onClick={this.handleEditProfile}>
            Edit Profile
          </NavLink>
          <NavLink
            onClick={this.handlePlansAndBilling}
            to="/profile/plans-and-billing"
            data-target="#plans-and-billing"
            aria-controls="plans-and-billing"
            aria-expanded="false"
            aria-label="Toggle Plans and Billing navigation menu"
          >
            Plans & Billing
          </NavLink>
          <div id="plans-and-billing" className="collapse navbar-collapse hide">
            <ul className="nav nav-pills flex-column">
              <NavLink to="/profile/plans-and-billing" onlyActiveOnIndex>
                My Plans
              </NavLink>

              {/* <NavLink to="/profile/plans-and-billing/invoices">Invoices</NavLink> */}

              <NavLink to="/profile/plans-and-billing/cards">Payment Details</NavLink>
            </ul>
          </div>
          <Link to="/" className="nav-link" onClick={this.handleLogout}>
            Logout
          </Link>
        </nav>
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(
    null,
    { logout }
  )
)(UserProfileNavbar);



// WEBPACK FOOTER //
// ./src/components/navigation/UserProfileNavbar/UserProfileNavbar.js